import ArtworkCredit from './ArtworkCredit';
import ArtworkSection from './ArtworkSection';

const heroImage = {
    jpg: '/art/western-luminism/rocky-mountains-landers-peak-bierstadt-1920.jpg',
    srcSet: [
        '/art/western-luminism/rocky-mountains-landers-peak-bierstadt-1280.jpg 1280w',
        '/art/western-luminism/rocky-mountains-landers-peak-bierstadt-1920.jpg 1920w',
    ].join(', '),
};

function HeroSection() {
    return (
        <ArtworkSection id="top" className="hero" image={heroImage}>
            <h1 className="sr-only">Aditya Patel</h1>
            <div className="hero-profile">
                <p>Software Engineer at Meta</p>
                <span>Instagram iOS · San Francisco</span>
            </div>
            <ArtworkCredit>
                Albert Bierstadt · <cite>The Rocky Mountains, Lander’s Peak</cite> · 1863
            </ArtworkCredit>
        </ArtworkSection>
    );
}

export default HeroSection;
